import ModalDialog from "app/common/ModalDialog/ModalDialog";
import { ModalObject } from "app/LineDelve";
import React, { useEffect, useState } from "react";
import { ComponentsContent } from "../common/NumberCard/NumberCardContent";
import computer from "../../assets/icons/global-icon-computer.svg";
import PhoneIphoneIcon from "../../assets/icons/global-icon-device-sim.svg";
import AlexaIcon from "../../assets/icons/alexa-icon.svg";
import BrandGlobalIcon from "../../assets/icons/Brand_Global_APIs_Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getDevicesDetails,
  resetSignOutDevice,
  sigingOutDevice,
} from "./actions";
import { RootState } from "app/reducers";
import Tooltip from "app/common/Tooltip";
//

export default function DeviceCard(props: any): React.ReactElement {
  const { deviceName, category, ownerId, deviceId, lastLoginTime } = props;
  const dispatch = useDispatch();
  const content = ComponentsContent?.ManageSignIn;
  let sharedLinesContent = ComponentsContent?.NumberCard?.sharedLines;
  const [modelObject, setModelObject] = useState<ModalObject>(
    content?.singnout
  );
  const [open, setOpen] = React.useState(false);
  const [isHover, setIsHover] = useState(false);
  const [signOutText, setSignOutText] = useState("Sign Out");
  const manageDevices = useSelector((state: RootState) => state.manageDevices);
  const handleCloseBtn = () => {
    setIsHover(false);
    setSignOutText("Sign Out");
    setOpen(false);
    dispatch(getDevicesDetails());
    dispatch(resetSignOutDevice());
  };

  const getsignOutId = (id: string) => {
    const uniqueID = id.split("-").pop();
    return "signout-" + uniqueID;
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (typeof ele === "string") {
      const targetEle: any = document.querySelector("#" + ele);
      if (event.keyCode === 9) {
        // targetEle.nextSibling.querySelector('span').focus()
      }
      if (event.keyCode === 13) {
        targetEle.click();
      }
    } else {
      if (event.keyCode === 13) {
        ele.current.click();
      }
    }
  };
  const handleSignOut = () => {
    setIsHover(true);
    setModelObject({
      ...content.singnout,
      content: content.singnout.content.replace("$DeviceName", deviceName),
      closeAction: handleCloseBtn,
    });
    setOpen(true);
    // setTimeout(function () {
    //   setModelObject({
    //     ...content.singnout,
    //     labelAction: '',
    //     labelClose: '',
    //     isPending: true,
    //   })
    // }, 3000)
  };

  const handleModalAction = () => {
    if (manageDevices.ownerId === "") {
      setIsHover(true);
      setSignOutText("Signing Out...");
      setModelObject({
        ...content.singingnout,
        isPending: true,
      });

      dispatch(sigingOutDevice({ ownerId: ownerId, deviceId: deviceId }));
    } else {
      if (manageDevices.error === "404" || manageDevices.error === "error") {
        window.open(sharedLinesContent.contactHelp, "_blank");
      }
      setOpen(false);

      dispatch(getDevicesDetails());

      dispatch(resetSignOutDevice());
    }
  };

  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    if (!open) setIsHover(false);
  };

  useEffect(() => {
    // if (manageDevices.ownerId === ownerId) {
    if (manageDevices.success) {
      setModelObject({
        ...content.signoutSuccess,
      });
    } else {
      if (manageDevices.error === "404") {
        setModelObject({
          ...content.signoutError404,
          content: content.signoutError404.content.replace(
            "$DeviceName",
            deviceName
          ),
          closeAction: handleCloseBtn,
        });
      } else {
        setModelObject({
          ...sharedLinesContent.oops,
          closeAction: handleCloseBtn,
        });
      }
    }
    //}
  }, [manageDevices.ownerId]);
  return (
    <React.Fragment>
      <div
        className={`manageContainer ${isHover ? "selected" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="deviceAvataar">
          {category?.toLowerCase() === "cdigits" && (
            <Tooltip title={content.toolTipsTitle.phoneIcon} placement="top">
              <img
                src={PhoneIphoneIcon}
                tabIndex={0}
                alt="Phone icon"
                width="40px"
                height="40px"
              ></img>
            </Tooltip>
          )}
          {category?.toLowerCase() === "webdigits" && (
            <Tooltip title={content.toolTipsTitle.webIcon} placement="top">
              <img
                src={computer}
                alt="computer icon"
                tabIndex={0}
                width="40px"
                height="40px"
              ></img>
            </Tooltip>
          )}
          {category?.toLowerCase() === "alexa" && (
            <Tooltip title={content.toolTipsTitle.alexaIcon} placement="top">
              <img
                src={AlexaIcon}
                alt="alexa icon"
                tabIndex={0}
                width="40px"
                height="40px"
              ></img>
            </Tooltip>
          )}
          {category?.toLowerCase() !== "alexa" &&
            category?.toLowerCase() !== "webdigits" &&
            category?.toLowerCase() !== "cdigits" && (
              <Tooltip
                title={content.toolTipsTitle.BrandGlobal}
                placement="top"
              >
                <img
                  src={BrandGlobalIcon}
                  alt="Brand Global icon"
                  tabIndex={0}
                  width="40px"
                  height="40px"
                ></img>
              </Tooltip>
            )}
        </div>
        <div className="contentContainer">
          <div className="signedDetails">
            <div className="detailrow">
              <div className="signedName" tabIndex={0}>
                {deviceName ? deviceName : "Unnamed"}
              </div>
              <div className="lastLoginTime-mobile" tabIndex={0}>
                {lastLoginTime}
              </div>
            </div>
            <div className="signedTimestamp">
              <div className="lastLoginTime-desktop" tabIndex={0}>
                {lastLoginTime}
              </div>
              <div
                className={`signOut ${isHover ? "selected" : ""}`}
                tabIndex={0}
                id={getsignOutId(deviceId)}
                onClick={handleSignOut}
                onKeyDown={(event) =>
                  handleKeyUp(event, getsignOutId(deviceId))
                }
              >
                {signOutText}
              </div>
            </div>
          </div>
          <div className="divider"></div>
        </div>
      </div>
      <ModalDialog
        openModal={open}
        modelObj={modelObject}
        dialogAction={handleModalAction}
        //uniquId={"deviceCard"}
      ></ModalDialog>
    </React.Fragment>
  );
}
